import React from 'react';
import { Row, Content, Message } from 'components/lib';
import { useEffect } from 'react';

export function CustomError(props) {

    useEffect(() => {
        document.title = props.title
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <Row>
            <Content>
                <Message
                    type='error'
                    title={props.title}
                    text={props.text}
                    buttonText={props.buttonText}
                    buttonLink={props.buttonLink}
                />
            </Content>
        </Row>
    );
}
